import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBox, FDContentContainer, FDPaper, FDStack,
} from '@facet-wealth/design';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { AccountOpeningAgreementError, accountOpeningAgreementErrorMetaOverrideSet } from './Errors/Error';

const Content = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  const hasErrors = resource.attr('errors')?.resources()?.list().length > 0;

  return (
    <FDStack direction={'column'} flexGrow={1} width={'100%'}>
      <PageContentContainer>
        <PageContentTop
          title={resource.attr('title')}
          subtitle={resource.attr('subtitle')}
        />
      </PageContentContainer>
      <FDPaper appearance={'flat'} color={'subtle'} flexGrow={1} padding={4} rounded={false}>
        <FDBox width={'100%'}>
          <FDContentContainer maxWidth={'sm'}>
            {!hasErrors && <MetaControlField attr={'disclaimers'} />}
            {hasErrors && (
              <MetaCollectionRenderer
                collection={resource.attr('errors')}
                layout={AccountOpeningAgreementError}
                metaOverrideSet={accountOpeningAgreementErrorMetaOverrideSet}
              />
            )}
          </FDContentContainer>
        </FDBox>
      </FDPaper>
    </FDStack>
  );
};

Content.propTypes = {};

export default Content;
